// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module__footer--SM135"};